import { TableCell } from '@mui/material'

import { useIndirizzoGara } from '../../hooks/utils-functions'

const TableCellAddress = ({ gara, ...cellProps }) => (
  <TableCell {...cellProps}>{useIndirizzoGara(gara)}</TableCell>
)

export default TableCellAddress
